
define('hooks',['jquery'], function($) {
  
  var Hooks = {};

  var hook_names = [
    'mapRendererBeginsRendering', 'mapRendererAddedMarker', 'mapRendererPushedMap', 'mapRendererFinishedRendering',
    'dataBagGotUserId', 'dataBagGotBag', 'dataBagAutoFilledForm', 'dataBagBeginsSubmit', 'dataBagBeginsPostBag', 'dataBagPostedBag'
  ];

  function get_callbacks(name) {
    if ($.inArray(name, hook_names) < 0) {
      return [];
    }

    if (typeof window.NGPVANEvents === 'undefined') {
      return [];
    }

    if (typeof window.NGPVANEvents.hooks === 'undefined') {
      return [];
    }

    if (typeof window.NGPVANEvents.hooks[name] === 'undefined') {
      return [];
    }

    if (typeof window.NGPVANEvents.hooks[name] === 'function') {
      return [window.NGPVANEvents.hooks[name]];
    }

    if (typeof window.NGPVANEvents.hooks[name] === 'object' && typeof window.NGPVANEvents.hooks[name].length === 'number') {
      var answer = [];

      for (var ind in window.NGPVANEvents.hooks[name]) {
        var func_candidate = window.NGPVANEvents.hooks[name][ind];
        if (typeof func_candidate === 'function') {
          answer.push(func_candidate);
        }
      }

      return answer;
    }

    return [];
  }

  function trigger(name) {
    var callbacks = get_callbacks(name);
    if (callbacks.length < 1) {
      return ;
    }

    var args = Array.prototype.slice.call(arguments, 1);

    for (var c in callbacks) {
      var func = callbacks[c];
      func.apply(func, args);
    }

    return ;
  }

  for (var ind in hook_names) {
    var hook_name = hook_names[ind];
    Hooks[hook_name] = (function() {
      var hook_name_local = hook_name;
      return function() {
        var args = Array.prototype.slice.call(arguments, 0);
        args.unshift(hook_name_local);
        trigger.apply(trigger, args);
      }
    })();

  }

  return Hooks;

});

